/**
 * Creates an onDownloadProgress handler for Axios that dispatches Redux actions.
 * @param {Function} dispatch The Redux dispatch function.
 * @param {string} progressActionType The action type for progress updates.
 * @param {string} finishActionType The action type for when the download finishes.
 * @returns {Function} The onDownloadProgress handler for Axios.
 */
export const createProgressHandler = (
  dispatch,
  progressActionType,
  finishActionType
) => {
  return (progressEvent) => {
    // Check if the total size is available to prevent division by zero
    if (progressEvent.total > 0) {
      const percentComplete = Math.floor(
        (progressEvent.loaded * 100) / progressEvent.total
      );

      // Dispatch the progress update
      dispatch({
        type: progressActionType,
        payload: percentComplete,
      });

      // Once the download is complete, dispatch the finish action
      if (percentComplete >= 100) {
        dispatch({
          type: finishActionType,
        });
      }
    }
  };
};
